<template>
  <v-btn
    variant="tonal"
    size="small"
    :color="presentation.color"
    :prepend-icon="presentation.icon"
    :title="accessibleTitle"
    class="recruitment-submission-status"
    @click.stop="$emit('open')"
  >
    {{ presentation.progress }}
  </v-btn>
</template>

<script>
import { submissionStatusPresentation } from "@/Utile/recruitmentSubmissions.mjs";

export default {
  name: "RecruitmentSubmissionStatusButton",
  props: {
    application: { type: Object, required: true },
  },
  emits: ["open"],
  computed: {
    presentation() {
      return submissionStatusPresentation(this.application);
    },
    accessibleTitle() {
      return this.$t(`recruitment.submission.status.${this.presentation.status}`, {
        progress: this.presentation.progress,
      });
    },
  },
};
</script>

<style scoped>
.recruitment-submission-status {
  min-width: 76px;
  letter-spacing: normal;
  text-transform: none;
}
</style>
